import { ClassNamesConfig, Props } from "react-select";
import Select from "../Select";
import { Control, Controller, Path } from "react-hook-form";
import { ErrorMessage } from "../ErrorMessage";
import { PlacesType } from "react-tooltip";

export type SelectControllerProps<T extends {}> = {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  markAsRequired?: boolean;
  labelIcon?: JSX.Element
  className?: string;
  inputClassName?: string;
  errorMessage?: string;
  triggerOnChange?: (e: any) => void;
  options: { label: string | JSX.Element, value: string | number; }[];
  customStyles?: ClassNamesConfig<unknown>;
  operationKlassToCheckPermission?: string;
  tooltipPlace?: PlacesType;
  tooltipMessage?: string;
  noPermissionText?: string;
  optionLabelFormat?: 'default' | 'icon',
} & Props;

const SelectController = <T extends {}>({
  control,
  name,
  label,
  markAsRequired,
  labelIcon,
  className,
  inputClassName,
  errorMessage,
  triggerOnChange,
  options,
  customStyles,
  optionLabelFormat = 'default',
  ...props
}: SelectControllerProps<T>) => {
  const { onChange: userOnChange, ...restProps } = props;

  return (
    <div className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ...field } }) => (
          <Select
            {...field}
            label={label}
            markAsRequired={markAsRequired}
            labelIcon={labelIcon}
            className={inputClassName}
            options={options}
            optionLabelFormat={optionLabelFormat}
            customStyles={customStyles}
            onChange={(newValue, actionMeta) => {
              onChange(newValue);
              userOnChange?.(newValue, actionMeta)
              triggerOnChange && triggerOnChange(newValue);
            }}
            {...restProps}
          />
        )}
      />
      {errorMessage ? <ErrorMessage name={name} message={errorMessage} /> : null}
    </div>
  );
};

export default SelectController;
